import { render } from "./NewsTable.vue?vue&type=template&id=67bc1e2a"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\puerto-antioquia-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__